import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import APIAMemberInformationForm from "webapp/components/Partner/APIA/APIAMemberInformationForm/APIAMemberInformationForm";
import { CYSUMemberInformationForm } from "webapp/components/Partner/CYSU/CYSUMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function CYSUMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [showSelectError, setShowSelectError] = useState(false);
  const [showMNFInputError, setShowMNFInputError] = useState(false);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [showNotCoveredMsg, setShowNotCoveredMsg] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const [acceptOOPConsent, setAcceptOOPConsent] = useState(false);
  const [MNFMemberInfoData, setMNFMemberInfoData] = useState({
    firstName: props.currState.MemberLookup.firstName || props.currState.FirstName || "",
    lastName: props.currState.MemberLookup.lastName || props.currState.LastName || "",
    phoneNumber: props.currState.MemberLookup.phoneNumber || props.currState.Number || "",
    memberNumber: props.currState.MemberLookup.memberNumber || "",
    purchaseDate: "",
    havingTrouble: props.currState.MemberLookup.havingTrouble || false,
    covered: false,
  });

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = (forceAcceptOOP = false) => {
    devLog("onUserNext", selectedContact);
    devLog("onUserNext MNFMemberInfoData", MNFMemberInfoData);

    const isMNFInputInValid =
      MNFMemberInfoData.havingTrouble &&
      (MNFMemberInfoData.firstName === "" ||
        MNFMemberInfoData.lastName === "" ||
        MNFMemberInfoData.phoneNumber === "" ||
        MNFMemberInfoData.memberNumber === "" ||
        MNFMemberInfoData.purchaseDate === "");

    devLog("isMNFInputInValid", isMNFInputInValid);

    if (isMNFInputInValid) {
      setShowMNFInputError(true);
      setShowSelectError(false);
      return;
    }

    if (!MNFMemberInfoData.havingTrouble && !selectedContact) {
      devLog(
        "!MNFMemberInfoData.havingTrouble && !selectedContact",
        !MNFMemberInfoData.havingTrouble && !selectedContact,
      );
      setShowSelectError(true);
      setShowMNFInputError(false);
      return;
    }

    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
    if (selectedContact && !MNFMemberInfoData.havingTrouble) {
      props.context.setState(
        {
          contactRef: selectedContact?.contactRef,
          Year: selectedContact.year,
          Make: selectedContact.make,
          Model: selectedContact.model,
          Color: selectedContact.color,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else if (!MNFMemberInfoData.covered && !acceptOOPConsent && !forceAcceptOOP) {
      setShowNotCoveredMsg(true);
      return;
    } else if (
      !isMNFInputInValid &&
      MNFMemberInfoData.havingTrouble &&
      (MNFMemberInfoData.covered || acceptOOPConsent || forceAcceptOOP)
    ) {
      devLog("!isMNFInputInValid MNFMemberInfoData", MNFMemberInfoData);
      devLog("MNFMemberInfoData.covered", MNFMemberInfoData.covered);
      props.context.setState(
        {
          MemberLookup: {
            ...MNFMemberInfoData,
            acceptOOPConsent: acceptOOPConsent || forceAcceptOOP,
          },
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */

      setShowSelectUserModal(true);
    }
  };

  const onAcceptNotCovered = () => {
    setShowNotCoveredMsg(false);
    setAcceptOOPConsent(true);
    onUserNext(true);
  };

  const promptCancelService = () => {
    setShowCancelConfirm(true);
  };

  const onConfirmCancelService = () => {
    setShowCancelConfirm(false);
    setShowNotCoveredMsg(false);
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onUserCancel = () => {
    promptCancelService();
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onUserSelectMember = (contactInfo) => {
    devLog("onUserSelectMember", contactInfo);
    // setMemberInfo(contactInfo);
    setSelectedContact(contactInfo);
    setShowSelectError(false);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("APIA.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <CYSUMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onSelect={onUserSelectMember}
          showSelectError={showSelectError}
          MNFMemberInfoData={MNFMemberInfoData}
          setMNFMemberInfoData={setMNFMemberInfoData}
        />
      </div>

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
      {showMNFInputError && (
        <Dialog
          title={"ErrorMNFInput"}
          message={"ErrorMNFInputMsg"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowMNFInputError(false);
          }}
        />
      )}

      {showNotCoveredMsg && (
        <Dialog
          title={"CoverageExpired"}
          message={"CoverageExpiredMsg"}
          buttonTitle={"CancelCallButton4"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Accept"}
          secondaryButtonAction={onAcceptNotCovered}
          preventDismiss={true}
          onClose={() => {
            setShowNotCoveredMsg(false);
          }}
        />
      )}

      {showCancelConfirm && (
        <Dialog
          title={"CancelCall1"}
          message={"CancelCall2"}
          buttonTitle={"No"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Yes"}
          secondaryButtonAction={onConfirmCancelService}
          onClose={() => {
            setShowCancelConfirm(false);
          }}
        />
      )}
    </>
  );
}

export default CYSUMemberInformation;
